import { render, staticRenderFns } from "./triplet_note.vue?vue&type=template&id=dd38c4f8&scoped=true"
import script from "./triplet_note.vue?vue&type=script&lang=js"
export * from "./triplet_note.vue?vue&type=script&lang=js"
import style0 from "./triplet_note.vue?vue&type=style&index=0&id=dd38c4f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd38c4f8",
  null
  
)

export default component.exports